import { createAction } from '@reduxjs/toolkit';

/** Actions handled by more than one slice; kept here so slices don't import each other */
export const customerLogOutSuccess = createAction(
  'customer/customerLogOutSuccess'
);
